/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

export const LoggerFactory = (event: string) => ({
  // eslint-disable-next-line no-console
  debug: (message) => console.log(event, message),
  error: (message) => console.error(event, message),
  // eslint-disable-next-line no-console
  info: (message) => console.info(event, message),
  // eslint-disable-next-line no-console
  trace: (message) => console.trace(event, message),
  warn: (message) => console.warn(event, message),
  get: () => LoggerFactory(event),
})
